import type { BillingProfileDomainQueryModel } from '@mntn-dev/domain-types'

export function billingProfileHasInvoicing(
  billingProfile: BillingProfileDomainQueryModel
) {
  return billingProfile.invoiceTerms !== 'none'
}
